var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloseModalNexplanon = function SvgCloseModalNexplanon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#ff84ab",
    rx: 15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    stroke: "#000",
    d: "M10.388 9.005 15 13.618l4.612-4.613 1.383 1.383L16.382 15l4.613 4.612-1.383 1.383L15 16.381l-4.612 4.612-1.382-1.382L13.618 15l-4.612-4.612z"
  })));
};
export default SvgCloseModalNexplanon;